import { getTotalPaymentValue } from "@Pages/Payment/utils";

import getCurrencySymbol from "helpers/getCurrencySymbol";

const getPaymentSummary = (paymentInfo: any = []) => {
  if (paymentInfo?.length > 0) {
    const total = getTotalPaymentValue(paymentInfo);
    const currency = getCurrencySymbol(total?.currency);
    const totalAmount = total?.amount_converted || total.amount;
    const paymentSummaryPriceCard = {
      currency,
      totalAmount,
    };
    return paymentSummaryPriceCard;
  }
  return {};
};

export default getPaymentSummary;
